if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    
    //vanilla JS fancybox
	
	if(document.getElementsByClassName('lightbox').length > 0){
        
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}
	}


    $('.sym-slides').slick();

    setTimeout(function(){
        $('.instagram_gallery').slick({
            slidesToShow: 4,
            accessibility:false,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        fade:true
                    }
                }
            ]
        });
    },1500);

    $('.gallery-slider__container').slick({
        slidesToShow: 4,
        accessibility:false,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    fade:true
                }
            }
        ]
    });

    let videoUrl;
    $('.open-video').click(function(event){
        event.preventDefault();
        videoUrl = $(this).attr('data-video');
    })
    $('.open-video').fancybox({
        afterShow   :   function() {
            $('#lightbox-video').attr('src',videoUrl);
            $('#lightbox-video')[0].play();
        },
        overlayShow : true,
        centerOnScroll : true,
        speedIn : 100,
        speedOut : 50,
        allowfullscreen:true,
        width         : '100%',
        height        : '100%',
        autosize: false
    });

})();